export const removeNonDigitsFromString = (s) => {
  if (!s) return s;
  return s.replace(/\D/g, "");
};

export const converterData = (d) => {
  if (!d) return d;
  return d.split("-")[2] + "/" + d.split("-")[1] + "/" + d.split("-")[0];
};

export const getValueFromObject = (obj, name, defaultValue) => {
  if (!!obj && !!name) {
    const paths = name.split(/[,[\].]+?/);
    let p = 0;
    while (obj && p < paths.length) {
      obj = obj[paths[p++]];
    }
    return obj === undefined ? defaultValue : obj;
  }

  return undefined;
};
